import {RequestType, UyapRequest} from "./UyapRequest";
import {IAdresDVORow, AdresRow} from "./CommonInterfaces";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";

export interface MtsTebligatGonderTalep {
    MTSTebligat: number,
    dosyaId: string,
    tebligatKisiKurumIdList: number[] | string,
    tebligatUcreti: number,
    odemeTipi: OdemeTipiEnum
}

export type MtsTebligatGonderCevap = Array<MtsTebligatGonderRow>;

export interface MtsTebligatGonderRow {
    evrakId: number,
    tarafTebligatDVO: ITarafTebligatDVORow,
}

export interface ITarafTebligatDVORow {
    pttDurum: number,
    hasTebligatEvrak: boolean,
    tebligatGGEvrakId: number,
    evrakKisiDVO: IEvrakKisiDVORow,
    adresDVO: IAdresDVORow,
    tebligatInputDVO: ITebligatInputDVO
}

export interface ITebligatInputDVO {
    inputDVO: IInputDVORow,
    dosyaKisiAdresDVO: IAdresDVORow,
    ggEvrakId: number
}

export interface IInputDVORow {
    tebligatNo: string,
    barkodNo: string,
    avukatId: number,
    avukatTckn: number,
    avukatAd: string,
    avukatSoyad: string,
    avukatIl: string,
    avukatIlce: string,
    avukatAdres: string,
    avukatEPosta: string,
    aliciAdSoyad: string,
    aliciIl: string,
    aliciIlce: string,
    aliciAyrintiliAdres: string,
    basimSayfaAdedi: number,
    basimUcret: number,
    birlesikEvrak: Array<any>,
    tebligatTuru: string,
    dosyaNumarasi: string,
    icraDairesi: string,

}

export interface IEvrakKisiDVORow {
    evrakKisiId: string,
    ggEvrakId: string,
    ilgiliDosyaKisiId: string,
    asilTarafDosyaKisiId: string,
    ilgiliKisiTipi: string,
    ilgili: string,
    dosya: IDosyaRow,
    ilgiliKisiIlkKisiKurumId: string,
    asilTarafIlkKisiKurumId: string,
    ilgiliKisiRolu: string,
    ilgiliKisiRolId: string,
    ilgilininHarcDurumu: string,
    sanikStatusu: string,
    secili: boolean,
    babaAdi: string,
    kisi: boolean,
    tcVatandasi: boolean,
    guncelKisiKurumId: number,
    mernisGuncellemesiYapildi: string,
    addresList: Array<AdresRow>
}

export interface IDosyaRow {
    clientDosyaDVO: IClientDosyaDVORow,
    dosyaTur: number
}

export interface IClientDosyaDVORow {
    dosyaID: string,
    dosyaNotSayisi: number,
    dosyaBilgileriTurKodu: number
}


export default class MtsTebligatGonder extends UyapRequest<MtsTebligatGonderTalep, MtsTebligatGonderCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "MTS tebligat gönderiliyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getRequestType(): RequestType {
        return "json"
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mtsTebligatGonder_brd.ajx';
    }

    async parse(data: any): Promise<MtsTebligatGonderCevap> {
        return data;
    }

    getMockResponse(): any {
        return [{"evrakId":10502893676,"tarafTebligatDVO":{"pttDurum":1,"tebligatGGEvrakId":13567067368,"hasTebligatEvrak":true,"evrakKisiDVO":{"evrakKisiId":"4194543872","ggEvrakId":"13567067367","ilgiliDosyaKisiId":"1430732437","asilTarafDosyaKisiId":"1430732437","ilgiliKisiTipi":"T","ilgili":"FULYA YÜZ","dosya":{"clientDosyaDVO":{"dosyaID":"tdafE@OMSDevOGWo3D4D0PqMkhwGjrlMDzPtwpzt3R1R@cDgmT@0b7IyLrWELLA9","dosyaNotSayisi":0,"dosyaBilgileriTurKodu":0},"dosyaTur":-1},"ilgiliKisiIlkKisiKurumId":"136438758","asilTarafIlkKisiKurumId":"136438758","ilgiliKisiRolu":"BORÇLU VE MÜFLİS","ilgiliKisiRolId":"22","ilgilininHarcDurumu":"1","sanikStatusu":"E","addresList":[{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"ODUNPAZARI","ilceKodu":14,"adres":"VİŞNELİK MAH.TAŞKÖPRÜ CAD.NO:29A","kisiKurumID":136438758,"adresID":251198296,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilceKodu":0,"postaKodu":"26000","adres":" AKARBAŞI MH AKIŞ SOK 23/2 Sok. Apartman No:  Numara:","kisiKurumID":136438758,"adresID":205700928,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"TEPEBAŞI","ilceKodu":15,"adres":"YENİBAĞLAR MAH. BOLAYIR SK. NO:16 İÇ KAPI NO:3","kisiKurumID":136438758,"adresID":134975882,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":0,"ilceKodu":0,"adres":" ","kisiKurumID":136438758,"adresID":345515651,"adresTuru":"ADRTR00010","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"TEPEBAŞI","ilceKodu":15,"adres":"ESKİBAĞLAR MH.KUMLUBEL SK.YILMAZ APT.NO:22/2","kisiKurumID":136438758,"adresID":163766274,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"TEPEBAŞI","ilceKodu":15,"adres":"    KUMLUBEL MAH.  AYDINLI SK.  Bina No: 68 Daire No: 8 MERKEZ/TEPEBAŞI/ESKİŞEHİR/TÜRKİYE ","kisiKurumID":136438758,"adresID":247052981,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"ODUNPAZARI","ilceKodu":14,"adres":"BÜYÜKDERE MAH. KAPLANLI SOK. NO:2/8","kisiKurumID":136438758,"adresID":186955685,"adresTuru":"ADRTR00005","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":0,"ilceKodu":0,"adres":" ","kisiKurumID":136438758,"adresID":301351214,"adresTuru":"ADRTR00010","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"TEPEBAŞI","ilceKodu":15,"adres":"ÇAMLICA MAH. OKUMUŞLAR SK. NO:2 İÇ KAPI NO:6 ","kisiKurumID":136438758,"adresID":188582981,"adresTuru":"ADRTR00010","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},{"ilKodu":0,"ilceKodu":0,"adres":"AKARBASI MAH AKIS SOK C1 BLOK N23/2 ODUNPAZARI ESKISEHIR","kisiKurumID":136438758,"adresID":176963846,"adresTuru":"ADRTR00001","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false}],"secili":false,"babaAdi":"FİRUZ","kisi":true,"tcVatandasi":true,"guncelKisiKurumId":136438758,"mernisGuncellemesiYapildi":"E"},"adresDVO":{"id":1430329992,"adresId":356941586,"dosyaId":"hcIuWBhJ5ymeLsU5as1V9GW071uXmK3@UES282hgcJki3jCy5wwYFx3vpwMF@Zvd","ilkKisiKurumId":136438758,"guncelKisiKurumId":136438758,"gizliYazismaAdresi":false,"kisikurumtur":"G","adresDVO":{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"ODUNPAZARI ","ilceKodu":14,"adres":"VİŞNELİK MAH. TAŞKÖPRÜ CAD.  NO: 29A ODUNPAZARI / ESKİŞEHİR","kisiKurumID":136438758,"adresID":356941586,"adresTuru":"ADRTR00001","adresTuruAciklama":"Yurt İçi İkametgah Adresi","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":true,"guncellendiMi":false,"aktif":"E"}},"tebligatInputDVO":{"inputDVO":{"tebligatNo":"2024/361953","barkodNo":"4100099425282","avukatId":1598212,"avukatTckn":22723845362,"avukatAd":"ONUR","avukatSoyad":"YÜKSEL","avukatIl":"ESKİŞEHİR","avukatIlce":"ODUNPAZARI ","avukatAdres":"Arifiye Mah. Yalbı Sok. Yılmazlar İş Mrk. No:18-816276-72776-45138 ODUNPAZARI  / ESKİŞEHİR","avukatEPosta":"av.onuryuksel@gmail.com","aliciAdSoyad":"BORÇLU VE MÜFLİS FULYA YÜZ","aliciIl":"ESKİŞEHİR","aliciIlce":"ODUNPAZARI ","aliciAyrintiliAdres":"Vişnelik Mah. Taşköprü Cad.  No: 29A Odunpazarı / Eskişehir Odunpazarı  / ESKİŞEHİR","basimSayfaAdedi":2,"basimUcret":144.6,"birlesikEvrak":[37,80,68,10],"tebligatTuru":"İdari Tebligat","dosyaNumarasi":"2024/361953","icraDairesi":"Eskişehir 7. İcra Dairesi"},"dosyaKisiAdresDVO":{"id":1430329992,"adresId":356941586,"dosyaId":"hcIuWBhJ5ymeLsU5as1V9GW071uXmK3@UES282hgcJki3jCy5wwYFx3vpwMF@Zvd","ilkKisiKurumId":136438758,"guncelKisiKurumId":136438758,"gizliYazismaAdresi":false,"kisikurumtur":"G","adresDVO":{"ilKodu":26,"ilAdi":"ESKİŞEHİR","ilceAdi":"ODUNPAZARI ","ilceKodu":14,"adres":"VİŞNELİK MAH. TAŞKÖPRÜ CAD.  NO: 29A ODUNPAZARI / ESKİŞEHİR","kisiKurumID":136438758,"adresID":356941586,"adresTuru":"ADRTR00001","adresTuruAciklama":"Yurt İçi İkametgah Adresi","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":true,"guncellendiMi":false,"aktif":"E"}},"ggEvrakId":13567067368}}}];
    }

}

